import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Código del proceso",
            headerName: getLocalizedString("processCodeAlt"),
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            headerName: getLocalizedString("group"),
            field: "group",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Nombre del proceso",
            headerName: getLocalizedString("processNameAlt"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Función al iniciar",
            headerName: getLocalizedString("functionOnStart"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Concepto para procesar",
            headerName: getLocalizedString("conceptToProcess"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Función al finalizar",
            headerName: getLocalizedString("functionWhenFinished"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.specialProcessExecution],
        config: {
            field: "Modo de ejecución",
            headerName: getLocalizedString("executionMode"),
            filter: "agSetColumnFilter",
        }
    },
]